export default __webpack_public_path__ + "static/media/play_icon_larg.af20c360.svg";